import { showConfigCommand } from '../../commands/config/showConfig';

export async function showConfigTui() {
  await showConfigCommand();
} 